var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('builder',{attrs:{"reportId":_vm.reportId},on:{"on-create":_vm.onReportCreate}})}
var staticRenderFns = []

export { render, staticRenderFns }